/**
 * UDP Onboarding Validation — single source of truth.
 *
 * UDP is a fully optional profile — users can skip any question.
 * canProceed() always returns true so the Continue button is never blocked.
 *
 * Backend Zod schemas still validate individual field FORMAT when submitted
 * (e.g., dateOfBirth must be a valid Date, whatsappNumber must be 7-15 digits
 * if provided). Those checks happen at submission time, not in the UI flow.
 *
 * @module udp-schema/validation
 */

/**
 * Check if the user can proceed from the current sub-step.
 *
 * In UDP every field is optional, so this always returns true.
 * The signature matches dating-schema's canProceed() for API consistency.
 */
export function canProceed(
  _fieldKey: string,
  _required: boolean,
  _form: Record<string, unknown>,
): boolean {
  return true;
}
